// extracted by mini-css-extract-plugin
export default {"mainTitle":"vahBA62GfeEqt0iaTNbi"};